
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsConnectEdcPortDialog extends Serenity.EntityDialog<PsConnectEdcPortRow, any> {
        protected getFormKey() { return PsConnectEdcPortForm.formKey; }
        protected getIdProperty() { return PsConnectEdcPortRow.idProperty; }
        protected getLocalTextPrefix() { return PsConnectEdcPortRow.localTextPrefix; }
        protected getNameProperty() { return PsConnectEdcPortRow.nameProperty; }
        protected getService() { return PsConnectEdcPortService.baseUrl; }
        protected getDeletePermission() { return PsConnectEdcPortRow.deletePermission; }
        protected getInsertPermission() { return PsConnectEdcPortRow.insertPermission; }
        protected getUpdatePermission() { return PsConnectEdcPortRow.updatePermission; }

        protected form = new PsConnectEdcPortForm(this.idPrefix);

    }
}